window.myapischoolTabChannel =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel("myapischool_tab")
    : null;

(function () {
  if (!window.myapischoolTabChannel) return;

  function init() {
    var meta = document.querySelector('meta[name="current-segment-id"]');
    var currentSegmentId = meta ? meta.content : null;

    if (!currentSegmentId) return;

    // Écouter les changements de segment des autres onglets
    window.myapischoolTabChannel.onmessage = function (event) {
      if (
        event.data.type === "SEGMENT_ACTIVE" &&
        String(event.data.segmentId) !== String(currentSegmentId)
      ) {
        // Toujours un autre onglet (BroadcastChannel n'émet pas vers soi-même)
        showBlockScreen();
      }
    };
  }

  function showBlockScreen() {
    document.body.innerHTML = [
      '<div style="',
      "display:flex;",
      "flex-direction:column;",
      "align-items:center;",
      "justify-content:center;",
      "height:100vh;",
      "font-family:sans-serif;",
      "background:#f8f9fa;",
      "text-align:center;",
      "padding:20px;",
      '">',
      '<h2 style="color:#dc3545;">&#9888; Conflit de session</h2>',
      '<p style="color:#6c757d;font-size:1.1rem;">',
      "Le campus a &eacute;t&eacute; modifi&eacute; dans un autre onglet.<br>",
      "Cette page n'est plus synchronis&eacute;e.",
      "</p>",
      '<button onclick="location.reload()" style="',
      "margin-top:16px;",
      "padding:10px 24px;",
      "background:#0d6efd;",
      "color:white;",
      "border:none;",
      "border-radius:5px;",
      "cursor:pointer;",
      "font-size:1rem;",
      '">',
      "Recharger la page",
      "</button>",
      "</div>",
    ].join("");
  }

  // Attendre que le DOM soit prêt
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
